@if (corporateTaxEntity$ | async) {
  <form [formGroup]="vragenFiscaleEenheidFg">
    <div class="row">
      <div class="col-7">
        <p>Is er sprake van voeging met bestaande dochtermaatschappijen?</p>
      </div>
      <div class="col-5">
        <snelstart-ui-select-form-control [options]="optionsJaNee"
                                          class="custom-input-150"
                                          formControlName="voegingMetBestaandeDochtermaatschappijen"
                                          id="voegingMetBestaandeDochtermaatschappijen"
        >
        </snelstart-ui-select-form-control>
      </div>
    </div>

    <div class="row">
      <div class="col-7">
        <p>Is er sprake van ontvoeging van dochtermaatschappijen?</p>
      </div>
      <div class="col-5">
        <snelstart-ui-select-form-control [options]="optionsJaNee"
                                          class="custom-input-150"
                                          formControlName="ontvoegingVanDochtermaatschappijen"
                                          id="ontvoegingVanDochtermaatschappijen"
        >
        </snelstart-ui-select-form-control>
      </div>
    </div>

    <div class="row">
      <div class="col-7">
        <p>Is er sprake van een beeindiging van de fiscale eenheid door liquidatie?</p>
      </div>
      <div class="col-5">
        <snelstart-ui-select-form-control [options]="optionsJaNee"
                                          class="custom-input-150"
                                          formControlName="beeindigingDoorliquidatieDochter"
                                          id="beeindigingDoorliquidatieDochter"
        >
        </snelstart-ui-select-form-control>
      </div>
    </div>

    <div class="row">
      <div class="col-7">
        <p>Verzoek meegeven verliezen ontvoegde dochter?</p>
      </div>
      <div class="col-5">
        <snelstart-ui-select-form-control [options]="optionsJaNee"
                                          class="custom-input-150"
                                          formControlName="verzoekMeegevenVerliezenOntvoegdeDochter"
                                          id="verzoekMeegevenVerliezenOntvoegdeDochter"
        >
        </snelstart-ui-select-form-control>
      </div>
    </div>

    <div class="row">
      <div class="col-7">
        <p>Verzoek de fiscale eenheid niet te verbreken vanwege juridische fusie?</p>
      </div>
      <div class="col-5">
        <snelstart-ui-select-form-control [options]="optionsJaNee"
                                          class="custom-input-150"
                                          formControlName="verzoekNietVerbrekenJuridischeFusie"
                                          id="verzoekNietVerbrekenJuridischeFusie"
        >
        </snelstart-ui-select-form-control>
      </div>
    </div>

    <div class="row">
      <div class="col-7">
        <p>Verzoek verliezen mee te geven aan de verkrijgende vennootschap bij fusie?</p>
      </div>
      <div class="col-5">
        <snelstart-ui-select-form-control [options]="optionsJaNee"
                                          class="custom-input-150"
                                          formControlName="verzoekMeegevenVerliezenVerkrijger"
                                          id="verzoekMeegevenVerliezenVerkrijger"
        >
        </snelstart-ui-select-form-control>
      </div>
    </div>

    <div class="row">
      <div class="col-7">
        <p>Verzoek de fiscale eenheid niet te verbreken bij verdwijnen van dochtermaatschappij?</p>
      </div>
      <div class="col-5">
        <snelstart-ui-select-form-control [options]="optionsJaNee"
                                          class="custom-input-150"
                                          formControlName="verzoekNietVerbrekenBijVerdwijnendeDochter"
                                          id="verzoekNietVerbrekenBijVerdwijnendeDochter"
                                          label=""
        >
        </snelstart-ui-select-form-control>
      </div>
    </div>

    <div class="row">
      <div class="col-7">
        <p>Verzoek meegeven van verliezen van verdwijnende dochter?</p>
      </div>
      <div class="col-5">
        <snelstart-ui-select-form-control [options]="optionsJaNee"
                                          class="custom-input-150"
                                          formControlName="verzoekMeegevenVerliezenvanVerdwijnendeDochter"
                                          id="verzoekMeegevenVerliezenvanVerdwijnendeDochter"
        >
        </snelstart-ui-select-form-control>
      </div>
    </div>
    <div class="row">
      <div class="col-7">
        <p>Verzoek meegeven uitdelingstekort aan ontvoegde dochter?</p>
      </div>
      <div class="col-5">
        <snelstart-ui-select-form-control [options]="optionsJaNee"
                                          class="custom-input-150"
                                          formControlName="verzoekMeegevenUitdelingstekort"
                                          id="verzoekMeegevenUitdelingstekort"
        >
        </snelstart-ui-select-form-control>
      </div>
    </div>
  </form>
}
